import request from '@/axios/index.js'
const uri = '/user/comprehensive/';

export function pagingQuotaList(data,loading) {
    return request.axios({
        data:data,
        url: uri+'pagingQuotaList',
        loading,
    })
}





// WEBPACK FOOTER //
// ./src/api/comprehensive.js